'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'UIComponents/decorators/Loadable';
import { ErrorLoadingAsync } from 'collaboration-sidebar/components/LoadingAsyncComponents';
import SidebarSkeleton from 'collaboration-sidebar/components/sidebar/CollaborationSidebar/SidebarSkeleton';
const AsyncCollaborationSidebarContainerWithSidebarSkeleton = Loadable({
  loader: () => import(
  /* webpackChunkName: "collaboration-sidebar" */
  'collaboration-sidebar/components/sidebar/CollaborationSidebar/CollaborationSidebarContainer').then(mod => mod.default),
  LoadingComponent: () => /*#__PURE__*/_jsx(SidebarSkeleton, {}),
  ErrorComponent: ({
    retry
  }) => /*#__PURE__*/_jsx(ErrorLoadingAsync, {
    retry: retry
  })
});
export default AsyncCollaborationSidebarContainerWithSidebarSkeleton;